document.addEventListener('DOMContentLoaded', function() {
  // Function to update button text with price
  function updateButtonWithPrice(variantElement) {
    const priceElement = variantElement.querySelector('.variant-price');
    const priceText = priceElement ? priceElement.textContent : '';
    const form = variantElement.closest('.variant-form');
    const button = form.querySelector('.variant-add-button');

    // Store original text if not already stored
    if (!button.dataset.originalText) {
      button.dataset.originalText = button.textContent;
    }

    // Update button text with price for mobile
    if (window.innerWidth <= 749) {
      button.innerHTML = `<span class="add-text">${button.dataset.originalText}</span><span class="price-text">${priceText}</span>`;
      button.classList.add('with-price');
    } else {
      // Reset to original text on desktop
      button.textContent = button.dataset.originalText;
      button.classList.remove('with-price');
    }
  }

  // Global function to handle variant selection
  window.selectVariant = function(element, productId) {
    // Remove selected class from all variants in this container
    const container = element.closest('.product-variants-container');
    container.querySelectorAll('.product-variant-option').forEach(option => {
      option.classList.remove('selected');
    });
    
    // Add selected class to clicked variant
    element.classList.add('selected');
    
    // Update hidden input with selected variant ID
    const variantId = element.getAttribute('data-variant-id');
    const hiddenInput = document.getElementById('SelectedVariant-' + productId);
    if (hiddenInput) {
      hiddenInput.value = variantId;
    }
    
    // Update button with price
    updateButtonWithPrice(element);
    
    // Prevent event from bubbling up to product card link
    event.stopPropagation();
  };

  // Function to handle single variant products
  function handleSingleVariants() {
    // Find all single-variant containers
    document.querySelectorAll('.product-variants-container.single-variant').forEach(container => {
      // Get the single variant option (should be the first and only real variant)
      const singleVariant = container.querySelector('.product-variant-option:not(.placeholder-variant)');
      if (singleVariant) {
        // Ensure it's selected
        singleVariant.classList.add('selected');
        
        // Get the product ID from the hidden input
        const hiddenInput = container.closest('.variant-form').querySelector('input[type="hidden"][name="id"]');
        if (hiddenInput) {
          const productIdMatch = hiddenInput.id.match(/SelectedVariant-(.*)/);
          if (productIdMatch && productIdMatch[1]) {
            const productId = productIdMatch[1];
            
            // Set the hidden input value to this variant's ID
            const variantId = singleVariant.getAttribute('data-variant-id');
            hiddenInput.value = variantId;
            
            // Update button with price
            updateButtonWithPrice(singleVariant);
          }
        }
      }
    });
  }

  // Initialize button text with price on page load and handle single variants
  document.querySelectorAll('.product-variant-option.selected').forEach(variantElement => {
    updateButtonWithPrice(variantElement);
  });
  
  // Handle single variants
  handleSingleVariants();

  // Update button text on window resize
  window.addEventListener('resize', function() {
    document.querySelectorAll('.product-variant-option.selected').forEach(variantElement => {
      updateButtonWithPrice(variantElement);
    });
  });

  // Handle form submissions to prevent navigation to cart
  document.querySelectorAll('.variant-form').forEach(form => {
    form.addEventListener('submit', function(event) {
      event.preventDefault();

      const formData = new FormData(form);
      const button = form.querySelector('.variant-add-button');
      const originalText = button.dataset.originalText || 'ADD TO CART';
      const priceText = button.querySelector('.price-text')?.textContent || '';

      // Show loading state
      if (window.innerWidth <= 749) {
        button.innerHTML = `<span class="add-text">Adding...</span>`;
      } else {
        button.textContent = 'Adding...';
      }
      button.disabled = true;

      // Submit the form data via fetch API
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(data => {
        // Success - show confirmation briefly before reload
        if (window.innerWidth <= 749) {
          button.innerHTML = `<span class="add-text">Added!</span>`;
        } else {
          button.textContent = 'Added!';
        }
        button.style.backgroundColor = '#4CAF50'; // Success green color

        // Instead of updating the count, force reload the page
        // This ensures the cart shows the most up-to-date items
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch(error => {
        // Error
        if (window.innerWidth <= 749) {
          button.innerHTML = `<span class="add-text">Error</span>`;
        } else {
          button.textContent = 'Error';
        }
        button.style.backgroundColor = '#F44336';

        // Reset button after delay
        setTimeout(() => {
          if (window.innerWidth <= 749) {
            button.innerHTML = `<span class="add-text">${originalText}</span><span class="price-text">${priceText}</span>`;
          } else {
            button.textContent = originalText;
          }
          button.style.backgroundColor = '';
          button.disabled = false;
        }, 2000);
      });
    });
  });
});
